import React, { useState } from "react";
import PrimaryButton from "../../utils/buttons/primaryButton";
import { HeaderText } from "../../Service/ServiceSetting/ServiceSettingIndex";
import { useTranslation } from "react-i18next";

function WeeklyOffSetting({ SettingContextData }) {
  const { t } = useTranslation();
  const { weekdays, onHandleWOS, applyWeeklySetting, SetApplyWeeklySetting } =
    SettingContextData;
  // console.log(weeklyCheckbox);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="flex flex-col gap-8 border border-black px-10 py-5  rounded-lg">
      <HeaderText text={t("serviceSetting.weeklyOffSetting")} />

      <div className="flex gap-6">
        <div className="flex  gap-4 flex-wrap">
          {weekdays.map((weekday, index) => (
            <CheckBoxComponent
              key={index}
              weekday={weekday}
              ServiceSettingContextData={SettingContextData}
            />
          ))}{" "}
        </div>
      </div>
      <div className="flex items-end gap-2">

      <input
        type="checkbox"
        checked={applyWeeklySetting}
        onChange={(e) => {
          SetApplyWeeklySetting((state) => !state);
        }}
        className="cursor-pointer mt-1 block w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
      />
         <label className="block text-base font-medium text-gray-700">
          {t("serviceSetting.applyWeeklySetting")} 
        </label>
        <span className="text-gray-500 ml-2">*{t("serviceSetting.thisWillAppliedToMonth")}</span>
      </div>
      <div>
        <PrimaryButton
          width="120px"
          className={"m-auto "}
          title={t("serviceSetting.update")}
          onClick={async () => {
            setIsLoading(true);
            try {
              await onHandleWOS();
            } catch (err) {
              console.log(err);
            } finally {
              setIsLoading(false);
            }
          }}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
const CheckBoxComponent = ({ weekday, ServiceSettingContextData }) => {
  const { weeklyCheckbox, setWeeklyCheckbox } = ServiceSettingContextData;

  const { t } = useTranslation();

  return (
    <div className="relative w-40">
      <div className="flex  flex-row gap-4">
        <input
          type="checkbox"
          checked={weeklyCheckbox[weekday]}
          onChange={(e) => {
            setWeeklyCheckbox((state) => ({
              ...state,
              [weekday]: !state[weekday],
            }));
          }}
          className="cursor-pointer mt-1 block w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
        />
        <label className="block text-base font-medium text-gray-700">
          {t(weekday?.toLowerCase())}{" "}
        </label>
      </div>
    </div>
  );
};
export default WeeklyOffSetting;
